import classnames from 'classnames'
import { Component } from 'preact'
import Focusable from './focusable'
import styles from './styles/modal.css'

export default class Modal extends Component {
  render({ children, additionalClass, ...restProps }) {
    return (
      <Focusable
        class={classnames(styles.modalOverlay, additionalClass)}
        {...restProps}>
        <div class={styles.modalComponent}>
          {children}
        </div>
      </Focusable>
    )
  }
}